import { render } from "./NavbarToggleButton.vue?vue&type=template&id=629147e4"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js"
script.render = render

export default script